import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TooltipPosition } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { globalVariable } from 'src/app/globalVariable/globalvariable';
import { CommonService } from 'src/app/services/common.service';
import { ConfirmDialogComponent } from 'src/app/shared-components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {
  showHome: boolean = false;
  showAdmin: boolean = false;
  token: string;

  constructor(private dialog: MatDialog, private router: Router, private commonServ: CommonService) { }

  ngOnInit(): void {

    this.commonServ.callingpublickey().subscribe((val) => {
      console.log("val alert", val)
      if (val.hasOwnProperty("publicKey")) {
        const publicKeyBase64 = val['publicKey'];
        globalVariable.publickey = publicKeyBase64;
        this.showHome = true;
      }
      this.commonServ.getroledeatils().subscribe((val) => {
        console.log("val", val)
        globalVariable.role_name = sessionStorage.getItem('role_name')
        console.log("templae", globalVariable.role_name);
        this.getrolebaseddetails(globalVariable.role_name)
      })
    })

    this.createInititals(sessionStorage.getItem("user_name"))
    console.log(this.hasSpaces(sessionStorage.getItem("user_name")))
    // console.log('routing to home');
    this.token = sessionStorage.getItem("jwttoken")
    this.router.navigate(['/home'])

  }

  screenName: String = 'Trust Centre'
  positionOptions: TooltipPosition[] = ['right'];
  positionOptionsNew: TooltipPosition[] = ['below'];
  initials: string = '';
  homeIcon: string = 'Home';
  AdminIcon: string = 'Administartion';

  tooltipPosition: TooltipPosition[] = ['right']
  homeIconImage = "./assets/home-icon.png"
  AdminIconimage = "./assets/icon-admin-w.png"
  mobileMenu() { }
  showProfile() { }

  doLogOut() {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        action: 'logout',
        header: 'Logout?',
        msg: 'Are you sure you want to log out?'
      }
    })
  }

  search() { }


  showhomeicon: boolean = false;
  showadminicon: boolean = false
  getrolebaseddetails(rolename: any) {
    if (rolename == "Trust Center Super Admin") {
      this.showhomeicon = true;
      this.showadminicon = true;
    }
    else if (rolename == "Trust Center Admin") {
      this.showhomeicon = true;
      this.showadminicon = true;
    } else if (rolename == "Trust Center User") {
      this.showhomeicon = true;
      this.showadminicon = false;
    }


  }


  hasSpaces(str) {
    if (str.indexOf(' ') !== -1) {
      return true
    } else {
      return false
    }
  }
  createInititals(name): void {

    let initials = "";


    if (this.hasSpaces(name)) {
      for (let i = 0; i < name.length; i++) {
        if (name.charAt(i) === ' ') {
          continue;
        }

        if (name.charAt(i) === name.charAt(i).toUpperCase()) {
          initials += name.charAt(i);

          if (initials.length == 2) {
            break;
          }
        }
      }

      this.initials = initials;
    } else if (!this.hasSpaces(name)) {
      initials = name.charAt(0).toUpperCase();
      this.initials = initials;
    }

  }

  downloadpdffile() {
    this.commonServ.downloadpdffile(5).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = 'example.pdf';
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
    })
  }

  checkMouseOver(icon) {
    if (icon == "showHome") {
      if (this[icon])
        this.homeIconImage = "./assets/home-icon-hover.png"
      else
        this.homeIconImage = "./assets/home-icon.png"
    }
    else if (icon == "showAdmin") {
      if (this[icon])
        this.AdminIconimage = "./assets/Admin-select.png"
      else
        this.AdminIconimage = "./assets/icon-admin-w.png"
    }
  }


  showScreen(ngVar, fileName, screenName, routeURL) {

    this.router.navigate([routeURL]);
    this.showHome = false;
    this.showAdmin = false;
    this[ngVar] = true
  }

  mouseOver(img, icon) {
    if (icon == 'showHome') {
      this.homeIconImage = img
    } else
      if (icon == 'showAdmin') {
        this.AdminIconimage = img
      }
  }

}